import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { DialogService } from '../../../services/dialog.service';
import { CommissionCalculator } from '../../../../features/sales/components/commission-calculator/commission-calculator';

@Component({
  selector: 'app-footer',
  imports: [
    RouterLink
  ],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private dialog = inject(DialogService);
  private router = inject(Router);

  currentYear: number = new Date().getFullYear();

  openCalculator() {
    this.dialog.open(CommissionCalculator,{
      panelClass: ['app-dialog-panel', 'commission-dialog'],
      width: '460px'
    });
  }

  goHome() {
    this.router.navigate(['/']);
  }
  
  goToFacebook() {
    window.open('https://www.facebook.com/people/Horizinns/61587447743091/', '_blank');
  }

  goToInstagram = (): void => {
    window.open('https://www.instagram.com/horizinns', '_blank');
  }

  goToYouTube() {
    console.log('goto youtube');
  }

  goToX = (): void => {
    window.open('https://www.x.com/horizinns', '_blank');
  }
}
